import Category from "./Category";
import Brand from "./Brand";
import Department from "./Department";
import Designation from "./Designation";
import CPU from "./CPU";
import Gen from "./Gen";
import Memory from "./Memory";
import HDD from "./HDD";
import SSD from "./SDD";
import Color from "./Color";
import GPU from "./GPU";
import Display from "./Display";
import Currency from "./Currency";

const Others = () => {
    return (
        <>
            <div className="grid">
                <div className="col-12 md:col-3">
                    <Category />
                </div>
                <div className="col-12 md:col-3">
                    <Brand />
                </div>
                <div className="col-12 md:col-3">
                    <Department />
                </div>
                <div className="col-12 md:col-3">
                    <Designation />
                </div>
            </div>

            <div className="grid">
                <div className="col-12 md:col-3">
                    <CPU />
                </div>
                <div className="col-12 md:col-3">
                    <Gen />
                </div>
                <div className="col-12 md:col-3">
                    <Memory />
                </div>
                <div className="col-12 md:col-3">
                    <HDD />
                </div>
            </div>

            <div className="grid">
                <div className="col-12 md:col-3">
                    <SSD />
                </div>
                <div className="col-12 md:col-3">
                    <Color />
                </div>
                <div className="col-12 md:col-3">
                    <GPU />
                </div>
                <div className="col-12 md:col-3">
                    <Display />
                </div>
            </div>
            <div className="grid">
                <div className="col-12 md:col-3">
                    <Currency />
                </div>
                <div className="col-12 md:col-3">

                </div>
                <div className="col-12 md:col-3">

                </div>
                <div className="col-12 md:col-3">

                </div>
            </div>
        </>
    )
}

export default Others;